import type { TFlightFormValues } from "@/types/types";

import { useFlightSearchDataContext } from "../../context/FlightSearchDataContext";
import { useFlightSortContext } from "../../context/FlightSortContext";
import { FlightTrackingEvents, rudderAnalytics } from "../../rudderstack";
import { getCityName } from "../../utils/locations";
import { usePreviousFlightSearchData } from "../usePreviousSearchData";

export const useFlightSearchForm = () => {
  const { setPreviousSearchData } = usePreviousFlightSearchData();
  const { resetSortValue } = useFlightSortContext();
  const { updateSearchData } = useFlightSearchDataContext();

  const handleSubmit = (values: TFlightFormValues) => {
    rudderAnalytics.track(FlightTrackingEvents.USER_SEARCHED_FOR_OFFERS, {
      tripType: values.tripType,
      departure_city: getCityName(values.from),
      destination: getCityName(values.to),
      travel_date: values.dates.departure,
      return_date: values.dates.return,
      travellers: values.adult + values.child,
    });
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData(values);
  };

  return { handleSubmit };
};
